import React, { useEffect, useState } from "react"
import { submitGuess, endGuessing, skipQuestion, endGame } from "./ballparkRoom"
import { Screen, BpButton, Pill, PlayerDot, C, F } from "./BallparkUI"
import { playSound } from "../../../utils/ballparkSounds"

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "back", "0", ""]

const GuessScreen = ({ room, code, playerId, isHost, question, setShowScores }) => {
  const [entry, setEntry] = useState("")
  const players = Object.entries(room.players)
  const guessedCount = Object.keys(room.guesses || {}).length
  const myGuess = room.guesses?.[playerId]
  const locked = myGuess !== undefined
  const allIn = guessedCount >= players.length

  useEffect(() => {
    if (allIn) endGuessing(code)
  }, [allIn, code])

  useEffect(() => setEntry(""), [room.questionIndex])

  const tap = (k) => {
    if (!k) return
    playSound("click")
    if (k === "back") setEntry((e) => e.slice(0, -1))
    else if (entry.length < 12) setEntry((e) => (e === "0" ? k : e + k))
  }

  return (
    <Screen style={{ gap: 14 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Pill>{code}</Pill>
          <span style={{ fontSize: 13, fontWeight: 700, color: C.muted }}>
            Round {room.round} of {room.totalRounds}
          </span>
        </div>
        <button
          onClick={() => {
            playSound("click")
            setShowScores(true)
          }}
          style={{
            background: C.panel,
            border: `1.5px solid ${C.borderDark}`,
            borderRadius: 12,
            padding: "4px 10px",
            fontFamily: F.display,
            fontWeight: 800,
            fontSize: 12,
            color: C.ink,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          🏆 Scores
        </button>
      </div>

      <div
        style={{
          background: C.card,
          border: `1.5px solid ${C.border}`,
          borderRadius: 20,
          padding: "22px 20px",
          boxShadow: `0 4px 0 ${C.border}`,
        }}
      >
        <span
          style={{
            background: C.gold,
            color: C.ink,
            fontWeight: 800,
            fontSize: 12,
            padding: "4px 10px",
            borderRadius: 999,
            letterSpacing: 0.5,
          }}
        >
          {question.category}
        </span>
        <div
          style={{
            fontFamily: F.display,
            fontWeight: 700,
            fontSize: 24,
            lineHeight: 1.25,
            marginTop: 12,
          }}
        >
          {question.question}
        </div>
        <div style={{ marginTop: 10, fontSize: 13, fontWeight: 600, color: C.muted }}>
          Closest guess without going over wins the pot.
        </div>
      </div>

      <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: 14 }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.muted, letterSpacing: 1 }}>
            YOUR GUESS
          </div>
          <div
            style={{
              fontFamily: F.display,
              fontWeight: 800,
              fontSize: 56,
              color: C.rust,
              borderBottom: `3px solid ${C.borderDark}`,
              display: "inline-block",
              minWidth: 160,
              padding: "0 12px 4px",
            }}
          >
            {locked ? myGuess : entry || " "}
          </div>
        </div>

        {!locked && (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8 }}>
              {KEYS.map((k, i) => (
                <button
                  key={i}
                  onClick={() => tap(k)}
                  disabled={!k}
                  style={{
                    height: 52,
                    background: k && k !== "back" ? C.panel : "transparent",
                    border: "none",
                    borderRadius: 12,
                    fontWeight: 800,
                    fontSize: k === "back" ? 15 : 22,
                    color: k === "back" ? C.muted : C.ink,
                    fontFamily: F.body,
                    cursor: k ? "pointer" : "default",
                  }}
                >
                  {k === "back" ? "⌫" : k}
                </button>
              ))}
            </div>
            <BpButton
              onClick={() => {
                playSound("bet")
                submitGuess(code, playerId, Number(entry))
              }}
              disabled={entry === ""}
            >
              Lock in my guess
            </BpButton>
          </>
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            fontSize: 13,
            fontWeight: 700,
            color: C.muted,
          }}
        >
          <span style={{ display: "flex" }}>
            {players
              .filter(([pid]) => room.guesses?.[pid] !== undefined)
              .map(([pid, p], i) => (
                <span key={pid} style={{ marginLeft: i ? -7 : 0, display: "inline-flex" }}>
                  <PlayerDot color={p.color} />
                </span>
              ))}
          </span>
          {guessedCount} of {players.length} guesses in
        </div>

        {isHost && (
          <>
            <BpButton
              variant="gold"
              onClick={() => {
                playSound("click")
                endGuessing(code)
              }}
              disabled={guessedCount === 0}
            >
              End guessing → open bets
            </BpButton>
            <div style={{ display: "flex", gap: 10 }}>
              <BpButton
                variant="panel"
                style={{ height: 48, fontSize: 14 }}
                onClick={() => {
                  playSound("click")
                  skipQuestion(code)
                }}
              >
                Skip question
              </BpButton>
              <BpButton
                variant="ghost"
                style={{ height: 48, fontSize: 13 }}
                onClick={() => {
                  playSound("click")
                  endGame(code)
                }}
              >
                End game
              </BpButton>
            </div>
          </>
        )}
      </div>
    </Screen>
  )
}

export default GuessScreen
